import { NativeScrollEvent } from 'react-native';

type ScrollEvent = Partial<NativeScrollEvent> &
  Required<
    Pick<
      NativeScrollEvent,
      'layoutMeasurement' | 'contentOffset' | 'contentSize'
    >
  >;

/**
 * Helper utility which can be used to report when a user has scroll within a given number of pixels to the bottom of the content
 *
 * @param {NativeScrollEvent} nativeScrollEvent A native scroll event containing the layout measurement, content offset and size
 * @param {number} pixelsToBottom The pixel count threshold within the bottom of the content
 *
 * @returns {boolean} true when scroll event is within a given threshold of the bottom, false otherwise
 */
export function isApproachingEndOfContent(
  { layoutMeasurement, contentOffset, contentSize }: ScrollEvent,
  pixelsToBottom: number,
): boolean {
  if (pixelsToBottom < 0) {
    return false;
  }

  return (
    layoutMeasurement.height + contentOffset.y >=
    contentSize.height - pixelsToBottom
  );
}

// Ensures the scroll offset is always between 0 and the max scroll distance
export const clampScrollOffset = (offset: number, maxScrollDistance: number) =>
  Math.min(Math.max(offset, 0), Math.max(0, maxScrollDistance));
